export default "__VITE_ASSET__BAFIwqSc__"